/** Feet → millimetres (Revit imperial internal units). */
export const FT_TO_MM = 304.8;

export const RAY_COUNT = 72;

/** BCA CABE §5.1.3 — larger accessible washroom inner clear size (mm). */
export const BCA_513_SHORT_MM = 1800;
export const BCA_513_LONG_MM = 2100;

export const BCA_513_RULE_ID =
  "vera:rule:bca-cabe-2019:5.1.3:accessible-washroom-clear-size";

export const ACCESSIBLE_ROOM_RX =
  /h'?cap|handicap|accessible|disabled|ambulant|barrier.?free|ada/i;

export const WC_POS_RX = /\bwc\b|toilet|water[ -]?closet/i;

export const WC_NEG_RX =
  /basin|flush\s*valve|hand\s*shower|paper\s*holder|seat\s*cover|spray|bidet|urinal|drain|trap|grating|scupper|sump|mixer|\btap\b|\bvalve\b|light|speaker|sensor|lavatory|maneuv/i;

export type RayHitKind = "boundary" | "opening" | "obstacle";

export interface RayCastHit {
  point: THREE.Vector3;
  kind: RayHitKind;
}

export type CastRayFn = (
  origin: THREE.Vector3,
  dir: THREE.Vector3
) => RayCastHit | null;

export interface ClearAabbResult {
  width: number;
  depth: number;
  box: THREE.Box3;
  points: THREE.Vector3[];
}

export interface AccessibleWcCandidate {
  dbId: number;
  roomName?: string;
  roomNumber?: string;
  displayName: string;
}

export interface WashroomMeasureResult {
  candidate: AccessibleWcCandidate;
  widthMm: number | null;
  depthMm: number | null;
  shortMm: number | null;
  longMm: number | null;
  geometry: ClearAabbResult | null;
  /** World-space ray origin at fixture centre + 750 mm (PSET convention). */
  rayOrigin?: THREE.Vector3;
}
